// extracted by mini-css-extract-plugin
export var arrow = "CarouselElements-module--arrow--77078";
export var next = "CarouselElements-module--next--ae910";
export var prev = "CarouselElements-module--prev--fc084";
export var white = "CarouselElements-module--white--1bddd";
export var wrapper = "CarouselElements-module--wrapper--8220f";